/**
 * Flow Optimizer Button
 * For Media Devoted | Created By Ciro Autiero
 *
 * Shown on the campaign flow card header (next to the flow name). Opens the optimizer drawer.
 */

import { FC, useState } from 'react';
import { Gauge } from 'lucide-react';

import { Button } from '@/components/ui/layout/Button';

import FlowOptimizerDrawer from './FlowOptimizerDrawer';
import type { FlowOptimizerProvider } from './services/flow-optimizer-api';

export interface FlowOptimizerButtonProps {
  campaignId: string;
  flowId: string;
  /** Defaults to 'voluum' for back-compat. */
  provider?: FlowOptimizerProvider;
  campaignName?: string;
  flowName?: string;
}

const FlowOptimizerButton: FC<FlowOptimizerButtonProps> = ({
  campaignId,
  flowId,
  provider = 'voluum',
  campaignName,
  flowName,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)} type="button">
        <Gauge className="mr-2 h-4 w-4 shrink-0" aria-hidden />
        Flow Optimizer
      </Button>
      <FlowOptimizerDrawer
        campaignId={campaignId}
        flowId={flowId}
        provider={provider}
        campaignName={campaignName}
        flowName={flowName}
        open={open}
        onOpenChange={setOpen}
      />
    </>
  );
};

export default FlowOptimizerButton;
